import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useTrackSharePetitionOnlineView } from 'src/app/pages/starterDashboardV2/shared/hooks';
import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';
import { Waypoint } from 'src/app/shared/components/scroll';

import { ShareSocial } from './components/ShareSocial';
import { ShareUrl } from './components/ShareUrl';

export const ShareYourPetition: React.FC = () => {
	const { actions } = useTrackSharePetitionOnlineView();
	return (
		<section data-testid="share_module" className="bg-background-base px-4 py-8 md:p-12">
			<Waypoint
				bottomOffset="30%"
				onPositionChange={(waypointCallbackArgs: WaypointCallbackArgs) => {
					actions.trackView(waypointCallbackArgs);
				}}
			/>
			<div className="flex flex-col gap-6">
				<Text className="text-size-heading-small text-typography-strong leading-8" as="h3" fontWeight="bold">
					<Translate value="corgi.petition.starter_dashboard.grow_petition.share_petition.title" />
				</Text>
				<div className="flex flex-col gap-6">
					<ShareSocial className="[@media(min-width:1204px)]:grid-flow-none grid grid-cols-[repeat(auto-fill,80px)] justify-between gap-y-6 [@media(min-width:1204px)]:flex [@media(min-width:1204px)]:grid-cols-none [@media(min-width:1204px)]:gap-x-2.5 [@media(min-width:1204px)]:gap-y-0 [@media(min-width:1204px)]:overflow-x-auto" />
					<ShareUrl />
				</div>
			</div>
		</section>
	);
};
